export default {
  shopName: 'Store Name',
  uploadStoreLogo: 'Upload Store Logo',
  shopType: 'Store type    ',
  countrySite: 'Store in country site',
  basicMarketplace: 'Basic marketplace',
  typeB: 'Brand authorized reseller / Distributor / Retailer',
  typeC: 'Basic Store',
  typeA: 'A类店铺',
  storeTypeB: 'Brand Official / Factory',
  shopQualification: 'Store Qualification',
  useMerchantQualification: 'Use main seller qualification',
  useNewQualification: 'Use new seller qualification',
  companyName: 'Name of Company    ',
  registerCode: 'License Number    ',
  location: 'Location    ',
  companyUpload: 'Upload business license photo    ',
  createShopSuccess: 'Create the store successfully    ',
  ruleMsgShopName: 'Please check the Store name    ',
  ruleMsgRegisterCode: 'Please check the license number',
  ruleMsgShopType: 'Please select store type',
  ruleMsgShopQualification: 'Please select store qualification',
  ruleMsgNoLogo: 'Please upload logo    ',
  ruleMsgOnlyOne: 'Only one logo can be uploaded',
  kilimall: 'Kilimall',
  marketPaymentAgreements: 'market payment related agreements',
  vatRegistered: 'VAT Registered?',
  yes: 'Yes',
  no: 'No',
  vatNo: 'VAT No.',
  uploadStoreLogoTip: 'Please upload a square image with a white background, no larger than 1Mb',
  phone: 'Phone',
  contactsReceivingSys: 'Contacts for receiving system notifications',
  onlyEnglishAndNumber: 'The store name can only consist of letters, numbers, and spaces.',
  storeNameExists: 'The store name you entered has already been taken.',
  requiredSettlementInfo: 'You have not yet completed all required settlement information.',
  continueFilling: 'Continue filling in the required information',
  skipStep: 'Skip this step and add the information later'
}
